import {
  LOCALIZATIONS_LOADING_START,
  LOCALIZATIONS_LOADING_SUCCESS,
  LOCALIZATIONS_LOADING_FAILED,
  CHANGE_LOCALIZATION_START,
  CHANGE_LOCALIZATION_SUCCESS,
  CHANGE_LOCALIZATION_FAILED,
  CHANGE_LOCALIZATIONS_PAGE,
  CHANGE_LOCALIZATIONS_LIMIT,
  //Поиск
  CHANGE_LOCALIZATIONS_SEARCH,
  START_LOCALIZATIONS_SEARCH,
  CLEAR_LOCALIZATIONS_SEARCH,
} from '../actions/localizationsList';

import { SIGN_OUT } from '../actions/auth';

const INITIAL_STATE = {
  ready: false,
  loading: false,
  loadingChange: false,
  localizations: {},
  local_total: 0,
  local_limit: 15,
  local_activePage: 1,
  local_search: '',
  local_activeSearch: '',
  sorting: {
    sort: 'created_at',
    order: true,
  },
  langMap: {
    'RU': 'Русский',
    'EN': 'English',
    'MN': 'Монгол хэл',
  },
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case LOCALIZATIONS_LOADING_START:
      return {
        ...state,
        ready: false,
        loading: true,
        localizations: {},
        local_total: 0,
      };
    case LOCALIZATIONS_LOADING_SUCCESS:
      return {
        ...state,
        ready: true,
        loading: false,
        localizations: action.payload.localizations.items,
        local_total: parseInt(action.payload.localizations.total, 10),
      };
    case LOCALIZATIONS_LOADING_FAILED:
      return {
        ...state,
        ready: false,
        loading: false,
      };
    case CHANGE_LOCALIZATION_START:
      return {
        ...state,
        loadingChange: true,
      }
    case CHANGE_LOCALIZATION_SUCCESS:
      return {
        ...state,
        loadingChange: false,
        localizations: {
          ...state.localizations,
          [action.payload.localization.key]: state.localizations[action.payload.localization.key].map(item => {
            if (item.id === action.payload.localization.id) {
              return action.payload.localization
            }
            return item
          })
        }
      }
    case CHANGE_LOCALIZATION_FAILED:
      return {
        ...state,
        loadingChange: false,
      }
    case CHANGE_LOCALIZATIONS_PAGE:
      return {
        ...state,
        local_activePage: action.payload.activePage,
      };
    case CHANGE_LOCALIZATIONS_LIMIT:
      return {
        ...state,
        local_limit: action.payload.activeLimit,
        local_activePage: INITIAL_STATE.local_activePage,
      };
    //Поиск
    case CHANGE_LOCALIZATIONS_SEARCH:
      return {
        ...state,
        local_search: action.payload.value
      };
    case START_LOCALIZATIONS_SEARCH:
      return {
        ...state,
        local_activeSearch: action.payload.value,
        local_activePage: INITIAL_STATE.local_activePage,
      };
    case CLEAR_LOCALIZATIONS_SEARCH:
      return {
        ...state,
        local_activeSearch: INITIAL_STATE.local_activeSearch,
        local_search: INITIAL_STATE.local_search,
        local_activePage: INITIAL_STATE.local_activePage,
      };
    case SIGN_OUT:
      return INITIAL_STATE;
    default:
      return state;
  }
}
